<template>
  <div>
    <div class="innews max-w">
      <div class="info">
        <div class="title">
          {{ info.name }}
        </div>
        <div class="message">
          <span>作者：{{ info.author ? info.author : "佚名" }}</span>
          <span>
            发布时间：{{ info.time ? info.time.replace(/-/g, "/") : "" }}</span
          >
        </div>
        <div class="infoBox ql-snow ql-editor" v-html="info.detail"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getListView } from "@/api/web";
export default {
  data() {
    return {
      info: {},
    };
  },
  watch: {
    $route: {
      handler: function () {
        this.getInfo();
      },
    },
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      getListView(this.$route.params.id).then((res) => {
        this.info = res.data;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.innews {
  margin: 30px auto;
  align-items: flex-start;

  .info {
    .title {
      font-size: 18px;
      text-align: center;
      color: #333333;
      line-height: 1.5;
      font-weight: bold;
    }
    .message {
      text-align: center;
      font-size: 16px;
      margin-top: 10px;
      color: #666666;
      span {
        padding: 0 8px;
      }
    }
    .infoBox {
      margin-top: 24px;
      line-height: 1.5;
      ::v-deep p {
        line-height: 1.5;
        margin: 1em 0;
        text-indent: 2em;
      }
      ::v-deep img {
        max-width: 100%;
        display: block;
      }
      ::v-deep .ql-align-center img {
        margin: 0 auto;
      }
      ::v-deep .ql-align-right img {
        margin: 0 0 0 auto;
      }
    }
  }
}
</style>
